import React, { FunctionComponent } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader } from 'rs-emd-ui-atoms';
import { useProfilePageQuery } from '../../generated/graphql';
import { ProfilePage } from '../../rs-emd-ui-modules/src/components/user';
import { RedirectWithStatus } from '../../rs-emd-ui-modules/src/helpers/redirect-with-status.component';
import { IContextInfo } from '../../rs-emd-ui-modules/src/models/master/context-info.model';
import { IProfilePage } from '../../rs-emd-ui-modules/src/models/profile/profile-page.model';
import { customerService } from '../../services/customer-service';

type ProfilePageWrapperProps = {
  contextInfo: IContextInfo;
  onboarding?: boolean;
};

export const ProfileWrapper: FunctionComponent<ProfilePageWrapperProps> = (props: ProfilePageWrapperProps) => {
  let location = useLocation();
  const isRedirectFromForgotPassword = Boolean(JSON.parse(new URLSearchParams(location.search).get('forgotPassword') ?? '0'));
  const isReviewingProfile = Boolean(JSON.parse(new URLSearchParams(location.search).get('review') ?? '0')) || props.onboarding;

  const { loading, error, data } = useProfilePageQuery({
    variables: { isOnboarding: props.onboarding ?? false },
    ssr: false,
    fetchPolicy: 'network-only',
  });

  if (loading) {
    return <Loader />;
  } else if (error || !data) {
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_ENDPOINT} statusCode={500} />;
  }
  // if user is not logged in
  else if (!data.profilePage.isSuccess) {
    return <Navigate to='/user/login?redirectTo=/user/profile' />;
  }

  return (
    <ProfilePage
      data={data.profilePage as IProfilePage}
      contextInfo={props.contextInfo}
      redirectFromForgotPassword={isRedirectFromForgotPassword}
      isReviewingProfile={isReviewingProfile}
      customerService={customerService}
    />
  );
};

export default ProfileWrapper;
